import { render, staticRenderFns } from "./DepositDeclineModal.vue?vue&type=template&id=08065c2f"
import script from "./DepositDeclineModal.vue?vue&type=script&lang=js"
export * from "./DepositDeclineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports